/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_CopyInputs */



/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Context_Menu_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy = /** @type {((inputs?: Context_Menu_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलिपि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cópia")
	return /** @type {LocalizedString} */ ("Copy")
});